/**
 * Returns the Tailwind class for a progress bar based on completion percentage.
 * 0% → parchment (empty), 100% → leather-dark (complete), in-between → leather-light
 */
export const barColor = (pct: number): string => {
  if (pct === 0) return 'bg-parchment-300';
  if (pct === 100) return 'bg-leather-dark';
  return 'bg-leather-light';
};

/**
 * Calculates the completion percentage of chapters, rounded to the nearest integer.
 */
export const calcProgressPct = (completed: number, total: number): number => {
  if (total === 0) return 0;
  return Math.round((completed / total) * 100);
};

/**
 * Returns the Tailwind size classes for chapter tiles based on total chapter count.
 * Books with > 50 chapters get smaller tiles.
 */
export const getTileSize = (totalChapters: number): string =>
  totalChapters > 50 ? 'w-7 h-7 text-[10px]' : 'w-9 h-9 text-xs';

/**
 * Returns the Tailwind color classes for a chapter tile.
 *
 * Interactive mode:
 *   - selected → bright green ring
 *   - prior (completed historically) → faded green
 *   - neither → gray
 *
 * Display mode:
 *   - completed → bright green
 *   - not completed → gray
 */
export const getTileClass = (
  isInteractive: boolean,
  isSelected: boolean,
  isPrior: boolean,
): string => {
  if (isInteractive) {
    if (isSelected) return 'bg-green-500 text-white shadow-sm ring-2 ring-green-300';
    if (isPrior) return 'bg-green-200 text-green-700';
    return 'bg-gray-100 text-gray-400';
  }
  return isPrior ? 'bg-green-500 text-white shadow-sm' : 'bg-gray-100 text-gray-400';
};
